import React, { ReactNode } from 'react';

import { createUniqueKey } from '../../../utils';

interface ChartLabelsProps {
    labels?: Array<string | ReactNode>;
}

const ChartLabels: React.FC<ChartLabelsProps> = ({
    labels = [],
}) => {
    return (
        <div className="chart-axis-labels">
            {labels.map((item, index) => (
                <div
                    key={createUniqueKey(index, item)}
                    className="chart-label"
                >
                    <div>{item}</div>
                </div>
            ))}
        </div>
    );
};

export default ChartLabels;